import { render, staticRenderFns } from "./centerTitle.vue?vue&type=template&id=8d2e26dc&scoped=true&"
var script = {}
import style0 from "./centerTitle.vue?vue&type=style&index=0&id=8d2e26dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2e26dc",
  null
  
)

export default component.exports